// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_List from "../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Float from "../../../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Result from "../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as AdjustFareAssetsManager from "../../../assets/AdjustFareAssetsManager.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";

var deleteIcon = AdjustFareAssetsManager.getImage("delete-icon.svg");

function makeSelectComponentList(data) {
  return List.map((function (incident_type) {
                return {
                        key: String(incident_type.id),
                        value: incident_type.name,
                        text: incident_type.name
                      };
              }), data);
}

function isIncidentalChargeOfGivenTypeExists(id, current_incidental_charges) {
  var filteredIncidentalCharge = List.filter(function (incident) {
          return id === incident.charge_type.id;
        })(current_incidental_charges);
  var match = Belt_List.length(filteredIncidentalCharge);
  return match !== 0;
}

var validators_amount = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, _metadata) {
      var amount = param.amount;
      if (amount !== undefined) {
        return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                        TAG: /* Float */3,
                        _0: amount
                      }), (function (distance) {
                      if (distance <= 0.0) {
                        return {
                                TAG: /* Error */1,
                                _0: "Amount cannot be less than or equal to 0.0"
                              };
                      } else {
                        return {
                                TAG: /* Ok */0,
                                _0: Belt_Float.fromString(distance.toFixed(2))
                              };
                      }
                    }));
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter incident amount"
              };
      }
    })
};

var validators_incidentType = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, metadata) {
      var incidentType = param.incidentType;
      if (incidentType === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please select incidental charge type"
              };
      }
      var output_id = Caml_format.caml_int_of_string(incidentType.key);
      var output_name = incidentType.value;
      var output = {
        id: output_id,
        name: output_name
      };
      if (isIncidentalChargeOfGivenTypeExists(Caml_format.caml_int_of_string(incidentType.key), metadata.current_incidental_charges)) {
        return {
                TAG: /* Error */1,
                _0: "Incidental charge of this type already exists in this order"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: output
              };
      }
    })
};

var validators = {
  amount: validators_amount,
  incidentType: validators_incidentType
};

function initialFieldsStatuses(_input) {
  return {
          amount: /* Pristine */0,
          incidentType: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            amount: /* Pristine */0,
            incidentType: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.amount;
  var match_0 = match ? match._0 : Curry._2(validators.amount.validate, input, metadata);
  var match$1 = fieldsStatuses.incidentType;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.incidentType.validate, input, metadata);
  var amountResult = match_0;
  var amountResult$1;
  if (amountResult.TAG === /* Ok */0) {
    var incidentTypeResult = match_0$1;
    if (incidentTypeResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                incidentType: incidentTypeResult._0,
                amount: amountResult._0
              },
              fieldsStatuses: {
                amount: /* Dirty */{
                  _0: amountResult,
                  _1: /* Shown */0
                },
                incidentType: /* Dirty */{
                  _0: incidentTypeResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    amountResult$1 = amountResult;
  } else {
    amountResult$1 = amountResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            amount: /* Dirty */{
              _0: amountResult$1,
              _1: /* Shown */0
            },
            incidentType: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurAmountField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.amount, validators_amount, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  amount: status,
                                  incidentType: init.incidentType
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurIncidentTypeField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.incidentType, validators_incidentType, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  amount: init.amount,
                                  incidentType: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateAmountField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.amount, state.submissionStatus, validators_amount, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            amount: status,
                                            incidentType: init.incidentType
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateIncidentTypeField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.incidentType, state.submissionStatus, validators_incidentType, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            amount: init.amount,
                                            incidentType: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                amount: /* Pristine */0,
                                incidentType: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                amount: /* Pristine */0,
                                incidentType: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateAmount: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAmountField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateIncidentType: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateIncidentTypeField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurAmount: (function (param) {
              return Curry._1(dispatch, /* BlurAmountField */0);
            }),
          blurIncidentType: (function (param) {
              return Curry._1(dispatch, /* BlurIncidentTypeField */1);
            }),
          amountResult: Formality.exposeFieldResult(state.fieldsStatuses.amount),
          incidentTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.incidentType),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.amount || match.incidentType) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function IncidentalChargesForm(Props) {
  var currency_symbol = Props.currency_symbol;
  var incident_charges_types = Props.incident_charges_types;
  var incidental_charges = Props.incidental_charges;
  var updateIncidentalCharges = Props.updateIncidentalCharges;
  var toggleAddIncidentalChargesButton = Props.toggleAddIncidentalChargesButton;
  var dispatch = Props.dispatch;
  var incidentalChargeForm = useForm({
        incidentType: undefined,
        amount: undefined
      }, {
        current_incidental_charges: incidental_charges
      }, (function (output, _form) {
          var incident = {
            charge_type: {
              id: output.incidentType.id,
              name: output.incidentType.name
            },
            amount: Currency.toCurrency(output.amount)
          };
          var updated_incidental_charges = Belt_List.add(incidental_charges, incident);
          Curry._1(updateIncidentalCharges, (function (param) {
                  return updated_incidental_charges;
                }));
          Curry._1(dispatch, {
                TAG: /* UpdatePreviewButtonStatus */6,
                is_preview_fare_button_enabled: true
              });
          return Curry._1(toggleAddIncidentalChargesButton, undefined);
        }));
  var value = incidentalChargeForm.input.amount;
  return React.createElement("div", {
              className: "c-add-incidental-charge-wrapper"
            }, React.createElement("form", {
                  className: "add-incidental-charge-form",
                  onSubmit: (function ($$event) {
                      $$event.preventDefault();
                      return Curry._1(incidentalChargeForm.submit, undefined);
                    })
                }, React.createElement("div", {
                      className: "c-incidental-charge-card-wrapper"
                    }, React.createElement("div", {
                          className: "incidental-charge-card-header"
                        }, React.createElement("p", {
                              className: "incidental-charge-header"
                            }, "Incidental Charges"), React.createElement("p", {
                              className: "icidental-charge-header-action-wrapper",
                              onClick: (function (param) {
                                  return Curry._1(toggleAddIncidentalChargesButton, undefined);
                                })
                            }, React.createElement("img", {
                                  className: "incidental-charge-remove-icon",
                                  src: deleteIcon
                                }), React.createElement("label", {
                                  className: "icidental-charge-header-action-label"
                                }, "Remove"))), React.createElement("div", {
                          className: "incidental-charge-card-body"
                        }, React.createElement("div", {
                              className: "incidental-charge-card-items"
                            }, React.createElement(Row$Catalyst.make, {
                                  children: React.createElement("div", undefined, React.createElement("label", undefined, React.createElement("label", undefined, "Type"), React.createElement("label", {
                                                className: "adjust-fare-mendatory-field-sign"
                                              }, "*")), React.createElement("div", {
                                            className: "incidental-dropdown"
                                          }, React.createElement(FormSelectInput$Catalyst.make, {
                                                input_props: FormInput$Catalyst.make_props("Select the type of incidental charge", (function ($$event) {
                                                        return Curry._2(incidentalChargeForm.updateIncidentType, (function (input, value) {
                                                                      return {
                                                                              incidentType: value,
                                                                              amount: input.amount
                                                                            };
                                                                    }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), makeSelectComponentList(incident_charges_types.incidental_charge_types)));
                                                      }), false, undefined, undefined, undefined, undefined, undefined, incidentalChargeForm.incidentTypeResult, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                                select_props: {
                                                  value: incidentalChargeForm.input.incidentType,
                                                  items: makeSelectComponentList(incident_charges_types.incidental_charge_types),
                                                  isNoneRequired: false
                                                }
                                              })))
                                })), React.createElement("div", {
                              className: "incidental-charge-card-items"
                            }, React.createElement(Row$Catalyst.make, {
                                  children: React.createElement("div", undefined, React.createElement("label", undefined, React.createElement("label", undefined, "Amount (" + currency_symbol + ")"), React.createElement("label", {
                                                className: "adjust-fare-mendatory-field-sign"
                                              }, "*")), React.createElement(FormTextInput$Catalyst.make, {
                                            input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                                    return Curry._2(incidentalChargeForm.updateAmount, (function (input, value) {
                                                                  return {
                                                                          incidentType: input.incidentType,
                                                                          amount: value
                                                                        };
                                                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                                  }), undefined, undefined, "Enter the amount for incidental charge", undefined, undefined, undefined, incidentalChargeForm.amountResult, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                            textinput_props: {
                                              value: value !== undefined ? value : ""
                                            }
                                          }))
                                })))), React.createElement("div", {
                      className: "c-add-incidental-charges-btn-wrapper"
                    }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Custom */1,
                                _0: (function (param) {
                                    return React.createElement("p", {
                                                className: "add-incidental-charges-btn-label"
                                              }, "Add");
                                  })
                              }, false, (function (param) {
                                  return Curry._1(incidentalChargeForm.submit, undefined);
                                }), undefined, undefined, undefined, undefined, "add-incidental-charges-btn", undefined, undefined)
                        }))));
}

var make = IncidentalChargesForm;

export {
  deleteIcon ,
  makeSelectComponentList ,
  isIncidentalChargeOfGivenTypeExists ,
  Form ,
  make ,
  
}
/* deleteIcon Not a pure module */
